/* eslint-disable no-inner-declarations */

var productSlider = $('.product-slider');
if (productSlider.length) {
    
    productSlider.each(function(index){
        var $slider = $(this);
        
        $slider
            .addClass('product-slider' + index)
            .parent()
            .find('.product-slider__nav-btn--next')
            .addClass('product-slider__nav-btn--next' + index)
            .end()
            .parent()
            .find('.product-slider__nav-btn--prev')
            .addClass('product-slider__nav-btn--prev' + index);

        // Initialize product slider
        var relatedSwiper = new Swiper('.product-slider' + index, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 44,
            navigation: {
                nextEl: '.product-slider__nav-btn--next' + index,
                prevEl: '.product-slider__nav-btn--prev' + index
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            }
        });
        
        // Run after resize
        relatedSwiper.on('resize', function() {
            positionNavButtons(productSlider.parent());
        });
        
        // Run on load
        $(window).on('load', function () {
            positionNavButtons(productSlider.parent());
        })
    });
}

// Calculate the top position of nav buttons to vertically
// center align them to slide image
function positionNavButtons(el) {
    el.each(function(){
        var $this = $(this);
        var navButtons = $this.find('.product-slider__nav-btn--prev, .product-slider__nav-btn--next');
        var slideImage = $this.find('.product-slider__slide').first().find('.product-list__image img');
        var navYCalculated = Math.round(slideImage.height() / 2);
        navButtons.css('top', navYCalculated);
    });
}